import React, {Component} from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import {NavLink} from 'react-router-dom'

export default class PaymentResult extends Component {
  calculateTotal () {
    let total = 0
    for (let index in this.props.items) {
      const item = this.props.items[index]
      total = total + item.parkTicketType.price
    }
    return total
  }

  render () {
    return (<div className="col-md-offset-2 col-md-8">
      <div className="panel panel-default panel-border">
        <div className="panel-body">
          <h2 className="title">Risultato Acquisto</h2>
          <p>
            {this.props.result.TransactionResult === 'KO' && <h3><strong>Spiacenti, si è verificato un errore...</strong>
              <p style={{margin: '1.5em', color: '#eb242e'}}>
                {this.props.result.ErrorCode} - {this.props.result.ErrorDescription}
              </p>
            </h3>}
          </p>

          {this.props.result.TransactionResult === 'OK' && <h3 style={{color: '#84b22f' }}>La transazione è avvenuta con <strong>successo!</strong>
            <p style={{margin: '1.5em'}}>
              {/* Esito: {this.props.result.TransactionResult}<br /> */}
              <h2> Totale: € {Number(this.props.result.Amount).toLocaleString('it-IT', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</h2>
            </p>
          </h3>}

          <div className="col-md-offset-4 col-md-4 text-center">
            <NavLink to={'/user-area'} className="btn btn-green" style={{margin: '1.5em'}}>Torna al profilo</NavLink>
          </div>
        </div>
      </div>
    </div>)
  }
}

PaymentResult.propTypes = {
  result: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/containers/UserArea/Checkout/PaymentResult.js